export default class DocumentService {

	private static instance: DocumentService;

	private constructor() {

	}

	/**
	* Get a singleton instance of DocumentService.
	*/
	public static getInstance(): DocumentService {
		if (!DocumentService.instance) {
			DocumentService.instance = new DocumentService();
		}
		return DocumentService.instance;
	}

	/**
	 * Loads data as a pdf document on a new browser tab.
	 * @param pdfData
	 */
	public async loadPDFDataToNewTab(pdfData: string) {
		let bytes: Uint8Array = await this.base64ToArrayBuffer(pdfData);

		let blob: Blob = new Blob([bytes], { type: 'application/pdf' });
		let fileURL: string = URL.createObjectURL(blob);
		window.open(fileURL, '_blank');
	}

	/**
	 * Downloads pdf data.
	 * @param pdfData
	 */
	public async downloadPDFData(pdfData: string, docName: string) {
		let bytes: Uint8Array = await this.base64ToArrayBuffer(pdfData);

		let blob: Blob = new Blob([bytes], { type: 'application/pdf' });
		let link: HTMLAnchorElement = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		let fileName: string = docName;
		link.download = fileName;
		link.click();
	}

	/**
	 * Downloads pdf data.
	 * @param data
	 */
	public async base64ToArrayBuffer(data: string): Promise<Uint8Array> {
		let binaryString: string = window.atob(data);
		let binaryLen: number = binaryString.length;
		let bytes: Uint8Array = new Uint8Array(binaryLen);
		for (var i = 0; i < binaryLen; i++) {
			var ascii = binaryString.charCodeAt(i);
			bytes[i] = ascii;
		}
		return bytes;
	}
}